import { default as BrightyMoneyPng } from './brand/brighty/BrightyMoney.png';
import { default as BrightyMoneyWebP } from './brand/brighty/BrightyMoney.webp';
import { default as BrightyMoneyAvif } from './brand/brighty/BrightyMoney.avif';
import { ImageProps, image } from './image';

export function GraphicsMoneyImage(props: ImageProps) {
  return __BRIGHTY__ ? image(props, BrightyMoneyPng, BrightyMoneyWebP, BrightyMoneyAvif) : null;
}
